 export enum RequeteurDomaineEnum {
Absence = 0,
Bulletin = 1,
Contrat = 2,
Reglement = 3,
Salarie = 4,
}


// WEBPACK FOOTER //
// ./src/dto/GenApi.iNotPaie.Dto/RequeteurDomaineEnum.ts